export const API_KEY = 'a350465a-ce76-4b5a-8608-fd671ad63546'
export const APP_NAME = 'TeamPay'
export const WIDGET_DISMISSED_KEY = 'teampay-download-widget-dismissed'

export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/teampayarmenia',
  linkedin: 'https://www.linkedin.com/company/teampay-cjsc',
  facebook: 'https://www.facebook.com/Teampay.am'
} as const

export const LOCALES = ['hy', 'en', 'ru']
export const APPSTORE_APP_ID = '6470545609'

export const APPSTORE_APP_ARGUMENT = `am.team.teampay://`
export const BASE_URL = 'https://teampay.am'
export const GOOGLE_ANALYTICS_ID = 'G-ERW91Y3GYE'
export const GOOGLE_TAG_MANAGER_ID = 'GTM-TCPN2WPK'
